import { agentGroupRef, type AgentAssociation } from '@reflex/shared';

/** What the group picker needs off an agent: its id, and the group it is in. */
export interface GroupTargetAgent {
  id: string;
  associations?: AgentAssociation[] | null;
}

/**
 * Whether filing this selection is a move: anything in it that is already in
 * a group has to leave that group, since a session is in one at a time.
 */
export function isFiledInAGroup(agents: GroupTargetAgent[]): boolean {
  return agents.some((agent) => agentGroupRef(agent) !== null);
}

/**
 * Names the action that opens the group picker. Filing is a move — a session
 * is in one group at a time — so a session that is already filed is leaving
 * one, and the entry that opens the picker says so before it is clicked.
 * Shared between the picker's own title and every menu that opens it, so the
 * two cannot disagree about what the click is going to do.
 */
export function groupActionLabel(agents: GroupTargetAgent[]): string {
  return isFiledInAGroup(agents) ? 'Move to group' : 'Add to group';
}
